import {
  AdsAssistantSlotFillFields,
  slotsSchemaFromTemplate,
} from "@/components/ads-assistant/AdsAssistantSlotFillFields";

export function AdsAssistantManualSlotFillSection(props: {
  canSeeSlotLabeledFields: boolean;
  canIngestPosts: boolean;
  slotsSchema: unknown;
  slotFillJsonText: string;
  setSlotFillJsonText: (v: string) => void;
}) {
  const { canSeeSlotLabeledFields, canIngestPosts, slotsSchema, slotFillJsonText, setSlotFillJsonText } = props;
  if (!canSeeSlotLabeledFields) return null;
  const slotsForFill = slotsSchemaFromTemplate(slotsSchema);
  return (
    <div className="rounded-lg border border-gray-200 bg-white/80 px-2 py-2 dark:border-gray-600 dark:bg-zinc-950/40">
      <p className="text-[11px] font-medium text-gray-800 dark:text-gray-200">Slot fills (optional)</p>
      <p className="mt-0.5 text-[10px] text-gray-500 dark:text-gray-500">
        Values are saved as <code className="rounded bg-gray-100 px-0.5 dark:bg-zinc-800">slot_fill_json</code> on the
        post.
      </p>
      <div className="mt-2">
        <AdsAssistantSlotFillFields
          slots={slotsForFill}
          slotFillJsonText={slotFillJsonText}
          setSlotFillJsonText={setSlotFillJsonText}
          disabled={!canIngestPosts}
        />
      </div>
    </div>
  );
}
